import React from 'react';
import styled from 'styled-components';
import { Buttons, Modal, Stack } from '@tymate/margaret';
import { fontStyles, SubText } from 'ui';
import { useTranslation } from 'react-i18next';
import { Box } from '@tymate/margaret';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form, PhoneField } from './Forms';
import { isValidPhoneNumber } from 'react-phone-number-input';
import Button from './Button';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { useApp } from 'hooks';

const CardTitle = styled(Box)`
  ${fontStyles.h3}

  margin: 0;
  font-weight: 700;
`;

CardTitle.defaultProps = {
  as: 'h3',
};

const UPDATE_PHONE = gql`
  mutation updatePhone($input: UpdatePhoneInput!) {
    updatePhone(input: $input) {
      user {
        id
        phone
      }
    }
  }
`;

const PhoneInputModal = ({
  onRequestClose,
  onSubmittedPhone,
  currentItem,
  isOpen,
}) => {
  const { t } = useTranslation(
    'account',
    'auth',
    'errors',
    'signature',
    'newRequest',
  );
  const [updatePhone] = useMutation(UPDATE_PHONE);
  const { user, notify } = useApp();

  const handleSaveNumber = async values => {
    // Save the number on the user
    try {
      await updatePhone({
        variables: {
          input: {
            userId: user.id,
            phone: values.phone,
          },
        },
      });
      onRequestClose(false);
      // Notify the uodate of the phone number
      notify(t('newRequest:update_phone_success'));
    } catch (err) {
      notify(t('newRequest:update_phone_success'));
      // console.dir(err);
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <Stack direction="column" gutterSize={1.5} alignX="stretch">
        <CardTitle style={{ marginBottom: -16 }}>
          {t('signature:recipient_phone')}
        </CardTitle>
        <SubText style={{ marginBottom: 0 }}>
          {t('account:phone_legend')}
        </SubText>

        <Formik
          onSubmit={handleSaveNumber}
          initialValues={{
            phone: '',
          }}
          validationSchema={Yup.object().shape({
            phone: Yup.string()
              .required(t('errors:required'))
              .test(
                'phone',
                t('errors:invalid_phone'),
                (value, context) => value == null || isValidPhoneNumber(value),
              ),
          })}
        >
          {({ isSubmitting, errors, values }) => (
            <Form>
              <Stack gutterSize={1} marginBottom={1.5}>
                <PhoneField
                  name="phone"
                  label={t('auth:phone')}
                  placeholder={t('phone_placeholder')}
                />
              </Stack>

              <Buttons paddingTop={1} alignX="flex-end">
                <Button type="button" onClick={onRequestClose}>
                  {t('cancel')}
                </Button>
                <Button
                  type="submit"
                  isLoading={isSubmitting}
                  variant="primary"
                >
                  {t('save')}
                </Button>
              </Buttons>
            </Form>
          )}
        </Formik>
      </Stack>
    </Modal>
  );
};

export default PhoneInputModal;
